var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-iframe mb20",style:(_vm.iframe.styleContainer)},[_c('iframe',{staticClass:"iframe",style:(_vm.iframe.styleIframe),attrs:{"src":_vm.url,"frameborder":"0","scrolling":"yes","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }